function setExternalLink(){
  const links = document.querySelectorAll('[data-external-link-tooltip]');
  for (let i = 0; i < links.length; i++){
    const temp = document.createElement('a');
    temp.href = links[i].getAttribute('href');
    links[i].setAttribute('data-external-link-tooltip', temp.hostname);
  }

  const menuLinks = document.querySelectorAll('.menu-item--external-link a');
  for (let j = 0; j < menuLinks.length; j++){
    const temp = document.createElement('a');
    temp.href = menuLinks[j].getAttribute('href');
    menuLinks[j].setAttribute('data-external-link-tooltip', temp.hostname);
  }
}

export default setExternalLink;
